import React from "react";
import PropTypes from 'prop-types';
import i33 from 'assets/images/i33.svg';
import i10 from 'assets/images/i10.svg';
import i4b from 'assets/images/i4b.svg';
import { Link } from 'react-router-dom';
import { css } from 'react-emotion';
import { withTranslated } from 'components/HOC';
import { Trans } from 'components';

const propTypes = {
  t: PropTypes.func.isRequired,
};

const EmptyCart = ({ t }) => (
  <div>
    <div className="nav-toppanel--user-card-dropdown empty">
      <div className="nt--empty-card-message">
        <div className="nt--empty-card-icon-outer">
          <div className="nt--empty-card-icon-inner a-bg-25">
            <img src={i33} alt="" />
          </div>
        </div>
        <h4 className="nt--empty-card-text">{t('Twój koszyk jest pusty')}</h4>
      </div>
      <div className="btn-container btn-container--btns-on-center">
        <div>
          <Link to="/products" className={`full-btn ${btnMargin}`}>
            <span className="nt-profile-btn--icon-l">
              <img src={i4b} alt="" />
            </span>
            <span><Trans>Wybierz z katalogu</Trans></span>
          </Link>
          <Link to="/orders" className={`stroke-btn ${btnMargin}`}>
            <span className="nt-profile-btn--icon-l">
              <img src={i10} alt="" />
            </span>
            <span><Trans>Ponów zamówienie</Trans></span>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

EmptyCart.propTypes = propTypes;
export default withTranslated(EmptyCart);

const btnMargin = css`
  margin: 15px auto;
`;


// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/cart/EmptyCart.jsx